import { FC } from "react";
import { ChevronRight } from "lucide-react";
import { MEDIUM_ICON_SIZE_STYLES } from "../../ui/styles";

export const ChevronIcon: FC = () => (
  <ChevronRight
    className={`justify-self-end text-stone-300 underline hover:text-stone-400 dark:text-stone-600 dark:hover:text-stone-500 ${MEDIUM_ICON_SIZE_STYLES}`}
  />
);
